import {FC, useRef, useState} from 'react'
import {ID} from '../../../../../shared/types/api'
import {letterValue} from '../utils/GuessWordUtils'

interface LetterProps {
    value: { value: string, realValue: string, id: ID },
    updateUserAnswers: (p: letterValue) => void,
    onAllCorrect?: () => void
}

const Letter: FC<LetterProps> = ({value, updateUserAnswers, onAllCorrect}) => {
    const [letter, setLetter] = useState(value.value || '')
    const inputRef = useRef<HTMLInputElement>(null)

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value
        const newLetter = raw.slice(-1).toUpperCase()
        setLetter(newLetter)
        updateUserAnswers({letterId: String(value.id), value: newLetter})
        if (newLetter === value.realValue) {
            moveToNextEmpty()
        }
    }

    const moveToNextEmpty = () => {
        const currentCell = inputRef.current?.closest('.guess-word__letter')
        if (!currentCell) return

        const allCells = Array.from(
            currentCell.closest('.guess-word-area__words')?.querySelectorAll('.guess-word__letter input') ?? []
        ) as HTMLInputElement[]

        const currentIndex = allCells.indexOf(inputRef.current!)
        const nextEmpty = allCells.find((inp, i) => i > currentIndex && !inp.value)

        if (nextEmpty) {
            nextEmpty.focus()
        } else {
            const anyEmpty = allCells.find(inp => !inp.value)
            if (anyEmpty) {
                anyEmpty.focus()
            } else {
                onAllCorrect?.()
            }
        }
    }

    const getAdditionClassName = (): string => {
        if (!letter) return ''
        return letter === value.realValue ? 'guess-word__letter-guessed' : 'guess-word__letter-failed'
    }

    return (
        <div className={'guess-word__letter ' + getAdditionClassName()}>
            <input
                ref={inputRef}
                type='text'
                value={letter}
                maxLength={1}
                onChange={onChange}
                autoComplete='off'
            />
        </div>
    )
}

export default Letter
